"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeminiService = void 0;
const core_1 = require("@angular/core");
const genai_1 = require("@google/genai");
let GeminiService = class GeminiService {
    constructor() {
        this.ai = null;
        this.apiKey = process.env.API_KEY;
        if (this.apiKey) {
            this.ai = new genai_1.GoogleGenAI({ apiKey: this.apiKey });
        }
        else {
            console.warn('Gemini API key not found. AI features will be disabled.');
        }
    }
    isConfigured() {
        return !!this.ai;
    }
    async generateText(prompt) {
        if (!this.ai) {
            return Promise.resolve("AI is not configured. Please set the API_KEY environment variable.");
        }
        try {
            const response = await this.ai.models.generateContent({
                model: 'gemini-2.5-flash',
                contents: prompt,
            });
            return response.text;
        }
        catch (error) {
            console.error('Error calling Gemini API:', error);
            return Promise.resolve(`Error: Could not generate text. ${error.message}`);
        }
    }
};
exports.GeminiService = GeminiService;
exports.GeminiService = GeminiService = __decorate([
    (0, core_1.Injectable)({ providedIn: 'root' }),
    __metadata("design:paramtypes", [])
], GeminiService);
